import React from 'react';

import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {
  Card,
  CardContent,
} from '@spaced-out/ui-design-system/lib/components/Card';
import {Chip} from '@spaced-out/ui-design-system/lib/components/Chip';
import {SemanticIcon} from '@spaced-out/ui-design-system/lib/components/Icon';
import {SubTitleLarge} from '@spaced-out/ui-design-system/lib/components/Text';

import {SeparatorWrapper} from '../../lib/helper-components/helper-components';
import {ScheduleDayCard} from '../../lib/sequence-day-card/sequence-day-card';
import {RootMachineContext} from '../../machines/rootMachine/rootMachine.context';
import {selectFormattedSequentialBookingData} from '../../selectors/event-details-selector';

import css from './sequential-booking-success.css';


export const SequentialBookingSuccess = () => {
  const {t} = useLabelTranslation();
  const formattedSequence = RootMachineContext.useSelector(
    selectFormattedSequentialBookingData,
  );

  return (
    <Card classNames={{wrapper: css.cardWrapper}}>
      <CardContent className={css.cardContent}>
        <div className={css.cardHeader}>
          <SemanticIcon
            type="solid"
            size="large"
            name="badge-check"
            semantic="success"
          />
          <SubTitleLarge>
            {t(
              'Thank_you_your_meeting_is_confirmed',
              'Thank you, your meeting is confirmed',
            )}
          </SubTitleLarge>
        </div>
        <div className={css.sequentialRounds}>
          {Array.isArray(formattedSequence) &&
            formattedSequence.map((sequenceItem, index) => {
              const currentItem = formattedSequence?.[index];
              const nextItem = formattedSequence?.[index + 1];
              const shouldShowSeparator =
                nextItem &&
                (currentItem?.type === 'day' || currentItem?.type === 'gap');

              if (sequenceItem.type === 'day') {
                return (
                  <React.Fragment
                    key={`day-${sequenceItem.dayNumber}-${index}`}
                  >
                    <ScheduleDayCard
                      isMultiDaySequence={formattedSequence.length > 1}
                      daySchedule={sequenceItem}
                    />
                    {shouldShowSeparator && <SeparatorWrapper />}
                  </React.Fragment>
                );
              } else if (sequenceItem.type === 'gap') {
                return (
                  <React.Fragment key={`gap-${index}`}>
                    {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
                    <Chip semantic="information">{sequenceItem.label}</Chip>
                    {shouldShowSeparator && <SeparatorWrapper />}
                  </React.Fragment>
                );
              }
              return null;
            })}
        </div>
      </CardContent>
    </Card>
  );
};
